import BaseProxy from './Base';

class FeedbackProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('feedback', parameters, 'api/v1');
  }

  addFrameFeedback({ job_id, frame_id, ...params } ) {
    this.endpoint = `${this.endpoint}/frames/${job_id}/${frame_id}`;
    return this.submit('put', `/${this.endpoint}`, params);
  }

  addJerseyFeedback({ detect_id, job_id, track_id, ...params }) {
    this.endpoint = `${this.endpoint}/tracks/${job_id}/${track_id}/${detect_id}`;
    return this.submit('put', `/${this.endpoint}`, params);
  }

  addTrackFeedback({ job_id, track_id, ...params }) {
    this.endpoint = `${this.endpoint}/tracks/${job_id}/${track_id}`;
    return this.submit('put', `/${this.endpoint}`, params);
  }

  getFrameFeedbackTypes() {
    this.endpoint = `${this.endpoint}/frames/types`;
    return this.load();
  }
  
  getTrackFeedbackTypes() {
    this.endpoint = `${this.endpoint}/tracks/types`;
    return this.load();
  }
}

export default FeedbackProxy;
